<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} COURSE</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- Course cover page -->
        <template v-if="dataUploadedFile">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataUploadedFile" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update CoverPage</vs-button>
            <vs-button type="flat" color="#999" @click="dataUploadedFile = null; dataImg = null">Remove CoverPage</vs-button>
          </div>         
        </template>
           <!-- Video upload Buttons -->
          <!-- <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateVidInput" @change="updateCurrVid" accept="video/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateVidInput.click()">Update Course</vs-button>
            <vs-button type="flat" color="#999" @click="dataVid = null">Remove Course</vs-button>
          </div> -->
      
        <!-- cousr cid -->
        <vs-input label="Cid" v-model="dataCid" class="mt-5 w-full" name="item-cid" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-cid')">{{ errors.first('item-cid') }}</span>

        <!-- Title -->
        <vs-input label="Title" v-model="dataTitle" class="mt-5 w-full" name="item-title" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-title')">{{ errors.first('item-title') }}</span>

        <!-- CATEGORY -->
        <!-- <vs-select v-model="dataCategory" label="Category" class="mt-5 w-full" name="item-category" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in category_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span> -->

        <!-- descirption -->
        <div class="mt-5 w-full">
          <label >Description</label>
          <vs-textarea v-model="dataDescription" name="item-description" v-validate="'required'"/>
        </div>
        <span class="text-danger text-sm" v-show="errors.has('item-description')">{{ errors.first('item-description') }}</span>

        <vs-input label="Course Duration" v-model="dataDuration" class="mt-5 w-full" name="item-duration" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-duration')">{{ errors.first('item-duration') }}</span>


        <!-- ORDER STATUS -->
        <!-- <vs-select v-model="dataStatus" label="Order Status" class="mt-5 w-full">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in status_choices" />
        </vs-select> -->

        <!-- PRICE -->
        <vs-input
          icon-pack="material-icons"
          icon="payment"
          label="Price"
          v-model="dataPrice"
          class="mt-5 w-full"
          v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }"
          name="item-price" />
        <span class="text-danger text-sm" v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span>

        <vs-checkbox v-model="enableCourse" class="mt-6">Make course live</vs-checkbox>
        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->

       <div class="upload-img mt-5" v-if="!dataUploadedFile">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Upload CoverPage</vs-button>
        </div>

        <!-- <div class="upload-vid mt-5" v-if="!dataVid">
          <input type="file" class="hidden" ref="uploadVidInput" @change="updateCurrVid" accept="video/*">
          <vs-button @click="$refs.uploadVidInput.click()">Upload Course</vs-button>
        </div> -->
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div> 
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {

      dataId: null,
      dataCid: null,
      dataTitle: null,
      dataCategory: null,
      dataImg: null,
      // dataVid:null,
      dataStatus: '',
      dataPrice: 0,
      dataDescription: null,
      dataDuration: 0,
      enableCourse: false,
      dataUploadedFile: false,

      // category_choices: [
      //   {text:'Robotics', value:'robotics'},
      //   {text:'Computers', value:'computers'}
      // ],

      // status_choices: [
      //   {text:'Live', value:'live'},
      //   {text:'Not Live', value:'not-live'}
      // ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {  _id, cid, category, coverPage, title, isEnabled, description, price, duration } = JSON.parse(JSON.stringify(this.data))
        // console.log('destructyred data', _id, cid, category, coverPage, title, isEnabled, description, price, duration)
        this.dataId = _id
        this.dataCid = cid
        this.dataCategory = category
        this.dataImg = coverPage
        this.dataUploadedFile = coverPage
        // this.dataVid = vid
        this.dataTitle = title
        this.enableCourse = isEnabled
        this.dataDescription = description
        this.dataPrice = price
        this.dataDuration = duration
        // this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataTitle && this.dataDescription && this.dataPrice > 0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data._id) return
      this.dataId = null
      this.dataTitle = null
      this.dataCategory = null
      this.dataStatus = ''
      this.dataPrice = 0
      this.dataImg = null
      this.dataUploadedFile = null
      this.dataDescription = null
      this.dataDuration = null
      this.enableCourse = null
      this.dataCid = null
      // this.dataVid = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            _id: this.dataId,
            cid: this.dataCid,
            title: this.dataTitle,
            description: this.dataDescription,
            file: this.dataImg,
            // vid: this.dataVid,
            duration: this.dataDuration,
            category: this.dataCategory,
            isEnabled: this.enableCourse,
            price: this.dataPrice
          }

          if (this.dataId !== null) {
            console.log('data to update', obj)
            this.$store.dispatch('courses/updateCourse', obj)
              .then(response => {
                this.successMsg(response.data.data)
              })
              .catch(err => { 
                console.error(err)
                this.errorMsg(err) 
              })
          } else {
            delete obj.id
            // obj.popularity = 0
            this.$store.dispatch('courses/addCourse', obj)
              .then(response => {
                this.successMsg(`${response.data.data.title} added`)
              })
              .catch(err => { 
                console.error(err)
                this.errorMsg(err)
              })
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        this.dataImg = input.target.files[0]
        this.dataUploadedFile = input.target.result
        // this.uplaodedFiles = [...this.uplaodedFiles, ...input.target.files]
        // console.log('multiple images', this.uplaodedFiles)
        reader.onload = e => {
          this.dataUploadedFile = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateCurrVid (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataVid = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    successMsg (message) {
      this.$vs.notify({
        title: 'Success',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    errorMsg (errMsg) {
      this.$vs.notify({
        title: 'Failed',
        text: errMsg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
        // position:'bottom-left'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
